import { createApp } from 'vue';
import App from './App.vue';
import {vuetify} from '@/plugins/vuetify';
import { pinia } from '@/stores';
import router from '@/router';

import { useAuthStore } from '@/stores/authStore';
import { setupAuthInterceptor } from '@/utils/authInterceptor';

import 'vuetify/styles';
import '@fortawesome/fontawesome-svg-core/styles.css';
//import '@/styles/main.css';
import '@/global.css';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(vuetify);
app.component('font-awesome-icon', FontAwesomeIcon);

const authStore = useAuthStore();
setupAuthInterceptor(authStore);

app.mount('#app');

/*
createApp(App)
    .use(pinia)
    .use(router)
    .use(vuetify)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app');
*/
